import { MailOutlined } from '@ant-design/icons';
import React, { ReactElement } from 'react';

/**
 * Renders a clickable email address with an edit icon for visual indication.
 * When clicked, it opens the user's default mail client when clicked.
 */
export default function EmailLink(props: {
    email: string;
}): ReactElement {
    const { email } = props;

    return (
        <a className='email-link' href={`mailto:${email}`}>
            {email}
            <MailOutlined />
        </a>
    );
}